import { render, staticRenderFns } from "./dialogTableRisks.vue?vue&type=template&id=0b377486&scoped=true&"
import script from "./dialogTableRisks.vue?vue&type=script&lang=js&"
export * from "./dialogTableRisks.vue?vue&type=script&lang=js&"
import style0 from "./dialogTableRisks.vue?vue&type=style&index=0&id=0b377486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b377486",
  null
  
)

component.options.__file = "dialogTableRisks.vue"
export default component.exports